// src/components/LeftOfferDetails.js
import React from 'react';

const LeftDetails = () => {
  return (
    <div className=''>
      <h2 className="text-4xl text-sky-950 md:text-5xl font-bold mb-8 offer-title">What We Offer</h2>
      <div className='first pb-2'>
        <h3 className="text-2xl text-sky-900 font-semibold mb-4 offer-subtitle">Software Development & Engineering Services</h3>
        <p className="text-stone-800">
          Driven by the top 1% of software engineering talent in India, we deliver robust, scalable,
          and reliable software product solutions to clients across the globe.
        </p>
      </div>
      <div className='sec pt-2'>
        <img src='/images/domain/RW2D.png' alt='Software Development & Engineering Services' />
      </div>
    </div>
  );
};

export default LeftDetails;